import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { removeFieldError } from 'apps/auth/actions/formAction';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import NewCardCvvField from 'apps/auth/components/form/NewCardCvvField';
import { PLUS_SUBSCRIBE_FORM_NAME } from 'apps/auth/constants/formName';
import { useForm } from 'apps/auth/hooks/selectors';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const CvvPopup = (props) => {
    const { fields } = useForm(PLUS_SUBSCRIBE_FORM_NAME);

    useEffect(() => {
        props.removeFieldError(props.formName, 'cvv');
    }, []);

    useEffect(() => {
        if (props.cvvIsError) {
            props.removeFieldError(props.formName, 'cvv');
        }
        if (props.cvvValue && props.cvvValue.length === 3) {
            props.onClick(fields);
            props.popupRef?.current?.close();
        }
    }, [props.cvvValue]);

    return (
        <ComplexPopup withoutButton textCenter popupRef={props.popupRef}>
            <ComplexPopupRow>{MarkdownService.removeNewlines(props.title)}</ComplexPopupRow>
            {fields.cvv && <NewCardCvvField field={fields.cvv} formName={props.formName} focus={true} isNewInput isCenteredInput />}
        </ComplexPopup>
    );
};
const mapStateToProps = (state) => {
    return {
        cvvValue: state.form[PLUS_SUBSCRIBE_FORM_NAME].fields['cvv']?.value,
        cvvIsError: state.form[PLUS_SUBSCRIBE_FORM_NAME].fields['cvv']?.isError,
    };
};
export default connect(mapStateToProps, { removeFieldError })(CvvPopup);
